import { render, staticRenderFns } from "./BankCardPaymentForm.vue?vue&type=template&id=606247a1&"
import script from "./BankCardPaymentForm.vue?vue&type=script&lang=js&"
export * from "./BankCardPaymentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports